import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { getAuthHeader, serverUrl } from ".";
import { PaginationType } from "../types/filter";

export const useProgressCount = () => {
  return useQuery({
    queryKey: ["progress", "count"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/progress/count`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const useProgress = () => {
  return useQuery({
    queryKey: ["progress"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/progress`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const useTrainingProgress = () => {
  return useQuery({
    queryKey: ["training_progress"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/progress/training`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};

export const usePatchTrainingProgress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await axios.patch(
        `${serverUrl}/progress/training`,
        data,
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["training_progress"] });
    },
  });
};

export const useStudentProgress = ({
  filters,
  pagination,
}: {
  filters: Record<string, string> | undefined;
  pagination: PaginationType;
}) => {
  return useQuery({
    queryKey: ["student_progress", filters, pagination],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/progress/student_progress`,
        {
          params: {
            filters: JSON.stringify(filters),
            start: (pagination.page * pagination.size).toString(),
            limit: pagination.size.toString(),
          },
          ...getAuthHeader(),
        }
      );
      return response.data;
    },
  });
};

export const usePostStudentProgress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await axios.post(
        `${serverUrl}/progress/student_progress`,
        data,
        getAuthHeader()
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["student_progress"] });
    },
  });
};

export const useProgressFields = () => {
  return useQuery({
    queryKey: ["student_progress_fields"],
    queryFn: async () => {
      const response = await axios.get(
        `${serverUrl}/progress/student_progress_fields`,
        getAuthHeader()
      );
      return response.data;
    },
  });
};
